import { useContext, useEffect, useState } from 'react';

import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import { GameContext, ViewContext } from '@/state/contexts';
import { performActionType } from '@/type/performAction';
import { createPossibleChoicesForCard, getCardMetadata } from '@/util/card';
import '@/style/HandModal.css';
import { logg } from '@/util/logg';
import { makeDecision } from '@lc/const/socketEvent';
import { createActionParams } from '@lc/interface/actionParams/factory';

/**
 * source (if any)
 * target (if any)
 * choice (if any) - will be from drop down as array of choices from card metadata
 *
 * TODO add a minimize/resize button so you can look at the gameState
 */

const DecisionCardResolutionServerModal = () => {
	const {
		currPlayer,
		// players,
		playerStateArray,
		// setSelectedAction,
		// selectedAction,
		// setSelectedActionCost,
		// selectedActionCost,
		// setSelectedCard,
		selectedCard,
		// setSelectedCardId,

		// serverDecisionPlayerId, // this is actually a boolean that we don't even need, this is activePlayer
		serverDecisionCardId,
		serverDecisionChoiceIds,
		serverDecisionSourceIds,
		serverDecisionTargetIds,

		selectedCardId,
		paymentObject, // if paying for card, send a full object with payment AND decision. If no payment object, choice is result of card resolving

		performAction,
	}: any = useContext(GameContext);

	const performActionTyped = performAction as performActionType;

	const { toggleMinimize }: any = useContext(ViewContext);

	const [card, setCard] = useState();
	const [sourceRequired, setSourceRequired] = useState(false);
	const [targetRequired, setTargetRequired] = useState(false);
	const [choiceRequired, setChoiceRequired] = useState(false);
	const [sourceId, setSourceId] = useState(-1);
	const [targetId, setTargetId] = useState(-1);
	const [choiceInt, setChoiceInt] = useState(0);

	// TODO if a turntype that's not a normalSeasonalTurn, take ques from server sent info to display the decision and its choices
	// should this just be a new modal?
	// TODO disable close modal if not normalSeasonalTurn
	// break out decision modal into different types of subsets to make it easier?

	useEffect(() => {
		const card = getCardMetadata(serverDecisionCardId);
		setCard(card);
		let cObj = createPossibleChoicesForCard(card); // TODO set decisions from current card

		logg('serverDecisionTargetIds');
		logg(serverDecisionTargetIds);

		setTargetRequired(cObj.targetReq);
		setSourceRequired(cObj.sourceReq);
		setChoiceRequired(cObj.choiceReq);

		setSourceId(currPlayer.playerId);
		if (serverDecisionTargetIds && serverDecisionTargetIds.length > 0) {
			setTargetId(serverDecisionTargetIds[0].player_id);
		}
		setChoiceInt(0);
	}, []);

	function makeChoice(e) {
		e.preventDefault();

		sendClientDecision();
	}

	function sendClientDecision() {
		logg('sending decision monsour DECISION CARD RESOLUTION SERVER MODAL');

		logg('currPlayer', currPlayer);
		logg('sourceId', sourceId);
		logg('targetId', targetId);
		logg('selectedCard', selectedCard);
		logg('selectedCardId', selectedCardId);

		const actionParams = createActionParams(
			selectedCardId,
			paymentObject,
			sourceId,
			targetId,
			choiceInt
		);

		performActionTyped(makeDecision, actionParams);

		/*
		sendClientAction(
			makeDecision,
			currPlayer,
			selectedCardId,
			paymentObject,
			sourceId,
			targetId,
			choiceInt // of the array of decision given, int of array element choice
		);
		*/
	}

	const handleSourceChange = (event) => {
		logg('currSource decision');
		const newSourceId = parseInt(event.target.value) || -1;
		logg(newSourceId);
		setSourceId(newSourceId);
	};

	const handleTargetChange = (event) => {
		logg('currTarget decision');
		const newTargetId = parseInt(event.target.value) || -1;
		logg(newTargetId);
		setTargetId(newTargetId);
	};

	const handleDecisionChange = (event) => {
		logg('handleDecisionChange decision');
		const newChoiceInt = parseInt(event.target.value) || -1;
		logg(newChoiceInt);
		setChoiceInt(newChoiceInt);
	};

	if (!card) return;

	return (
		<div className="modal" onClick={toggleMinimize}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={toggleMinimize}>
					&minus;
				</span>
				<h2>MAKE A CHOICE</h2>
				{/** Boolean thing here for PR turn selection */}
				<SeasonalCard
					cardId={serverDecisionCardId}
					width={0}
					height={0}
				/>
				{serverDecisionSourceIds &&
					serverDecisionSourceIds.length > 0 && (
						<div>
							Source:
							<select
								id="sourceSelect"
								value={sourceId}
								onChange={handleSourceChange}
							>
								{playerStateArray.map((source) => (
									<option
										key={source.playerId}
										value={source.playerId}
									>
										{source.color}
									</option>
								))}
							</select>
						</div>
					)}
				{serverDecisionTargetIds &&
					serverDecisionTargetIds.length > 0 && (
						<div>
							Target:
							<select
								id="targetSelect"
								value={targetId}
								onChange={handleTargetChange}
							>
								{serverDecisionTargetIds.map((pState) => (
									<option
										key={pState.player_id}
										value={pState.player_id}
									>
										{pState.color}
									</option>
								))}
							</select>
						</div>
					)}
				{serverDecisionChoiceIds &&
					serverDecisionChoiceIds.length > 0 && (
						<div>
							Decision:
							<select
								id="DecisionSelector"
								value={choiceInt}
								onChange={handleDecisionChange}
							>
								{(card as any).decision.map((d) => (
									<option key={d.text} value={d.id}>
										{d.text}
									</option>
								))}
							</select>
						</div>
					)}
				<button value={0} onClick={(e) => makeChoice(e)}>
					Confirm Choice
				</button>
			</div>
		</div>
	);
};

export default DecisionCardResolutionServerModal;
